import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import Geometry from "@fae/source/utility/Geometry.js"

import Dice from "@fae/source/data/games/ember/views/Dice.jsx"
import DiceCube from "@fae/source/data/games/ember/views/DiceCube.jsx"

import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

import "./FirstTimeRollModal.less"

function onClick(stage) {
    return (event) => {
        window.hasRolled = true
        CarryOn(stage)
    }
}

export default function RollModal() {
    return PlotSteps.CustomViewModal({
        "view": (stage) => {
            if(App?.game == undefined) return
            const units = Object.values(stage.units).filter((unit) => {
                return unit.isDead != true
                    && unit.isLockedIn != true
                    && unit.affiliation == stage.player.affiliation
                    && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
            })
            if(units.length == 0) return
            return (
                <div class="FirstTimeRollModal">
                    <div class="Fill"/>
                    <div class="Content">
                        <div class="Header">
                            <div class="BigText">Roll the Dice</div>
                        </div>
                        <section class="UnitsSection" onClick={onClick(stage)}>
                            {units.map((unit) => {
                                return (
                                    <DiceCube item={unit.items[0]} unit={unit} stage={stage} animation="spin"/>
                                )
                            })}
                        </section>
                        <div class="Footer" style={{"opacity": 0}}>
                            <div class="BigText">Roll the Dice</div>
                        </div>
                    </div>
                </div>
            )
        }
    })
}
